import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { BaaRequestDecisionComponent } from './baa-request-decision/baa-request-decision.component';
import { BaaRequestListComponent } from './baa-request-list/baa-request-list.component';
import { BaaRequestFlowService } from './baa-request-flow.service';
import { FfdNotesInviteDecisionComponent } from './ffd-notes-invite-decision/ffd-notes-invite-decision.component';

@Component({
  selector: 'lib-baa-request-flow',
  imports: [BaaRequestDecisionComponent, BaaRequestListComponent, FfdNotesInviteDecisionComponent, LottieComponent],
  templateUrl: './baa-request-flow.component.html',
  styleUrl: './baa-request-flow.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BaaRequestFlowService],
})
export class BaaRequestFlowComponent implements OnInit {
  protected readonly service = inject(BaaRequestFlowService);
  private readonly activatedRoute = inject(ActivatedRoute);

  public readonly lottieOptions: AnimationOptions = {
    path: '/assets/animations/loading-spinner.json',
  };

  public ngOnInit(): void {
    this.service.initialize(this.activatedRoute.snapshot.queryParamMap);
  }
}
